<template>
  <el-dialog
    title="精彩纵横云采购平台用户注册协议"
    :visible.sync="showDialog"
    width="70rem"
    :close-on-click-modal="false"
    :append-to-body="true"
    :before-close="closeDialog"
  >
    <p>请务必认真阅读和理解本《用户注册协议》（以下简称《协议》）中规定的所有权利和义务。除非您接受本《协议》条款，否则您无权注册、登录或使用精彩纵横云采购平台（以下简称“精彩纵横”）所涉及的相关服务。您一旦注册、登录、使用或以任何方式使用精彩纵横涉及的相关服务的行为将视为对本《协议》的接受，即表示您同意接受本《协议》各项条款的约束。</p>
    <p>一、特别提醒</p>
    <p>1.本协议的个别条款可能会根据业务需要不时地进行调整，一旦条款内容发生变动，将会在本网站以公告的方式予以公布。若您继续使用、接受精彩纵横的服务，视为您已充分阅读、理解并接受修改后的协议内容；若您不同意修改后的协议内容，您有权停止使用精彩纵横的服务。</p>
    <p>2．本协议内容包括协议正文及所有精彩纵横已经发布或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。</p>
    <p>二、用户</p>
    <p>1.精彩纵横的用户是具有完全民事行为能力，能够承担相应法律责任的自然人、法人或其他组织。若您不具备此资格，请不要使用精彩纵横提供的服务，否则您及您的监护人应承担因此而导致的一切后果，且精彩纵横有权注销（永久冻结）您的账户，并向您及您的监护人索偿。如您代表一家公司或其他法律主体在精彩纵横登记，则您须声明和保证您已获得该公司或其他法律主体的授权，您有责任和义务使该公司或该法律主体受本协议条款的约束。</p>
    <p>2.精彩纵横的服务将不提供给那些被精彩纵横临时或永久取消会员资格的自然人、法人或其他组织。</p>
    <p>三、注册条款</p>
    <p>1.若您申请注册成为精彩纵横的用户，您须遵守以下规则：</p>
    <p>（1）申请注册时，根据精彩纵横的要求，提供真实、准确、即时、完整的注册信息，否则将承担由此所引起的一起责任和义务；</p>
    <p>（2）维护并及时更新注册信息以保持其真实、准确、即时、完整。</p>
    <p>2.在注册过程中，您可自主选择一个登录名和密码。您应妥善保管您的登录名和密码，并对通过该账号进行的所有行为负责。</p>
    <p>四、使用条款</p>
    <p>精彩纵横不对用户注册提供的任何有关信息内容的真实性、适用性、合法性承担责任。您对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。</p>
    <p>您同意并承诺：</p>
    <p>1、您对通过精彩纵横发布的所有信息，包括但不限于注册信息、采购信息的准确性、完整性、即时性、合法性都独立承担所有责任。您应当准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码等联系方式，以便精彩纵横或其他用户与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用精彩纵横服务过程中产生任何损失或增加费用的，应由您完全独自承担。您了解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按精彩纵横的要求进行操作。否则，精彩纵横有权中止或者终止您的相关服务或者精彩纵横帐号的使用，精彩纵横对此不承担任何责任。</p>
    <p>2、在精彩纵横上发布信息或者利用精彩纵横的服务时必须符合中国有关法律、法规，不得在精彩纵横上或者利用精彩纵横的服务制作、复制、发布、传播以下信息：</p>
    <p>（1）反对宪法所确定的基本原则的；</p>
    <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>（3）损害国家荣誉和利益的；</p>
    <p>（4）煽动民族仇恨、民族歧视、破坏民族团结的；</p>
    <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p>（9）含有法律、行政法规禁止的其他内容的。</p>
    <p>3、在利用精彩纵横服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
    <p>4、不以任何方式干扰精彩纵横的服务。</p>
    <p>5、遵守精彩纵横的所有其他规定和程序。</p>
    <p>您需对自己在使用精彩纵横服务过程中的行为承担法律责任。用户理解，如果精彩纵横发现其消息内容明显属于上段第2条所列内容之一，依据中国法律，精彩纵横有义务立即停止其服务，保存有关记录，向国家有关机关报告，并且删除含有该内容的消息。</p>
    <p>6、您使用精彩纵横服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本协议，对于您违法或违反本协议的行为而引起的一切责任，由您负全部责任，一概与精彩纵横无关，导致精彩纵横损失的，精彩纵横有权要求您赔偿，并有权立即停止提供服务，保留相关记录，保留配合司法机关追究法律责任的权利。</p>
    <p>7、用户之间通过精彩纵横与其他用户交易，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失，由过错方依法承担所有责任，一概与精彩纵横无关。</p>
    <p>8、当您注册成为会员后，精彩纵横会向您注册时提供的联系方式（包括但不限于电子邮箱、手机号码等）发送精彩纵横通知或与本网站服务相关的各类商业性电子信息，前述信息进入接收系统时，视为送达。如您不同意继续接收商业性电子信息须通过书面形式通知我们。</p>
    <p>五、信息收集</p>
    <p>当您注册成为精彩纵横的用户时，精彩纵横需要收集您的姓名、手机号码、电子邮箱（Email）地址等信息。当您浏览精彩纵横时，服务器会自动收集您的IP地址。精彩纵横有权收集供应商及其产品信息、采购商的采购信息，构建数据库系统。除非会员许可或法律需要，精彩纵横不会泄露与某一用户直接相关的上述信息。具体的信息收集及使用规则，请参看精彩纵横《隐私策略》。</p>
    <p>六、费用</p>
    <p>精彩纵横保留收取服务费用的权利。请注意：精彩纵横不承担您因使用精彩纵横的服务而需支付的软硬件、税收及其它费用。精彩纵横保留在未经书面通知，仅在网站公示的情况下随时改变或不继续提供某些或全部服务（暂时性的或永久的）。</p>
    <p>平台提供的增值性服务在开通时请确认您购买的服务无误，服务开通后款项将不予退还。</p>
    <p>七、中止及终止</p>
    <p>1．对于用户的以下行为，精彩纵横有权在告知或未经告知的情况下中止或终止相关服务或者拒绝其以任何形式使用精彩纵横，并不因此承担任何责任，且保留追究您法律责任的权利：</p>
    <p>（1）利用精彩纵横进行违法、违纪或违反本协议规定的活动；</p>
    <p>（2）提供的信息不真实、不准确、不即时、不完整；</p>
    <p>（3）利用精彩纵横滥发重复信息或者发布与精彩纵横服务无关的信息；</p>
    <p>（4）未经授权向精彩纵横会员发送大量与业务不相关的信息；</p>
    <p>（5）冒用他人的名义发布信息；</p>
    <p>（6）计划破坏、攻击精彩纵横电脑系统、网络的完整性，或者试图擅自进入精彩纵横电脑系统、网络；</p>
    <p>（7）使用或提供含有毁坏、干扰、截取或侵占任何系统、数据或个人资料的任何电脑病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他破坏性程序；</p>
    <p>（8）盗用他人在精彩纵横上的登录名或密码；</p>
    <p>（9）未经精彩纵横书面同意，擅自允许他人使用精彩纵横服务（包括但不限于擅自允许他人使用其登录名或密码，或者擅自将其登录名或密码转让给他人的），或者通过精彩纵横获得相关信息。</p>
    <p>2．您同意，精彩纵横有权基于合理的怀疑并经电子邮件通知的情况下中止或者终止您的相关服务或者精彩纵横帐号的使用，精彩纵横对此不承担任何责任。</p>
    <p>3．一旦您的服务被终止，您将不能在精彩纵横上发布信息，也不能让别人代为发布信息；您在精彩纵横的注册资料及所有相关信息均会被删除或丢弃；同时对您服务终止前的行为，精彩纵横保留追究您法律责任的权利。</p>
    <p>八、责任声明</p>
    <p>1．精彩纵横将尽力核查用户提交的信息，并依照有关法律法规以及网站运营规则进行审核、发布或删除用户提交的信息，但不能完全保证信息的真实性、准确性和合法性。</p>
    <p>2．精彩纵横含有与其他网站的链接。精彩纵横并不能控制这些网站及其所提供的资源，所以精彩纵横对链接网站上的内容、广告、服务、产品信息的真实性、准确性、完整性及有效性不做任何承诺，且不因此承担任何责任。</p>
    <p>3．精彩纵横不保证网站是不受干扰的、没有故障的，也不对使用效果做任何保证。精彩纵横不对因人为或非人为因素造成的会员与精彩纵横服务器之间的连接受阻而无法访问负责。您同意独立承担因网站意外中断、操作或传输的迟延、电脑病毒、网络连接故障、未经授权的进入等引起的损失。</p>
    <p>4．因不可抗力（包括但不限于自然灾害、罢工或骚乱、暴动、战争行为、政府行为等）以及因互联网的特殊性而产生的包括黑客攻击、互联网连通中断或者系统故障、电信部门技术调整导致的影响、政府管制而造成的暂时性关闭在内的任何影响网络正常运营的因素等非精彩纵横原因，致使精彩纵横履行迟延或不能履行的，精彩纵横不对您承担任何责任。但精彩纵横应在不可抗力发生后及时通知会员并采取措施，尽最大努力减轻可能给会员造成的损失。</p>
    <p>5．精彩纵横将尽最大努力来减少错误，但网站上提供的服务和信息仍可能包含错误内容，精彩纵横对用户因使用精彩纵横而造成的损失不负法律责任。精彩纵横对其服务和信息不作保证，不论什么情况下对用户因使用精彩纵横而造成的直接、间接、偶尔的、特殊的、惩罚性的损害或其他一切损害不负法律责任，即便事先被告知损害存在的可能性也是如此。若您对精彩纵横提供的部分或所有服务不满，您有权停止使用这些服务。</p>
    <p>6．精彩纵横无法保证用户所公布的信息的真实性、及时性、安全性和正确性，您应独立承担因使用精彩纵横而产生的风险。精彩纵横希望您在使用本网站时，小心谨慎并运用常识。</p>
    <p>7.对使用“不正当手段在平台获利”的用户，平台保留依法追究的权利。</p>
    <p>九、知识产权</p>
    <p>1．精彩纵横上所有内容的选材、整理、编排、排版、汇编，以及由精彩纵横创作的文字、图片、商标等的著作权，无论是否明示，均属精彩纵横所有。任何自然人、法人或其他组织未经精彩纵横书面授权或许可，不得修改、出版、传播、参与传播、销售、制作衍生作品，或以其他任何方式使用整体或部分的精彩纵横上提供的产品、服务和功能。</p>
    <p>2．精彩纵横上所有可阅读的资料等都受到《中华人民共和国著作权法》、《中华人民共和国商标法》等的法律保护。精彩纵横尊重和保护他人的知识产权，不允许在没有著作权、商标权或其他专有权权利人明确许可的情况下，发布或者传播任何可能侵犯他人权利的信息、图片，否则，行为人承担由此产生的全部责任。</p>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserAgreement',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    closeDialog() {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
 p {
   text-indent: 2em;
   text-align: left;
   margin: 0;
   line-height: 1.8;
 }
</style>